import { AuthResponse, LoginCredentials, User } from "@types";
import api from "./api";

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await api.post("/auth/login/", {
      email: credentials.email,
      password: credentials.password,
    });
    // Backend now returns { user: {...}, tokens: { access, refresh } }
    return response.data;
  },

  async logout(refreshToken: string): Promise<void> {
    try {
      await api.post("/auth/logout/", { refresh: refreshToken });
    } catch {
      // Ignore logout errors - user is logged out locally anyway
    }
  },

  async refreshToken(refreshToken: string): Promise<{ access: string }> {
    const response = await api.post("/auth/token/refresh/", {
      refresh: refreshToken,
    });
    return response.data;
  },

  async getProfile(): Promise<User> {
    console.log("[AuthService] Fetching profile from /auth/me/");
    const response = await api.get("/auth/me/");
    console.log("[AuthService] Profile response:", response.data);
    // Backend now returns camelCase fields directly
    return response.data;
  },

  async updateProfile(data: Partial<User>): Promise<User> {
    const response = await api.patch("/auth/me/", {
      firstName: data.firstName,
      lastName: data.lastName,
      phone: data.phone,
      timezone: data.timezone,
      language: data.language,
    });
    // Backend returns updated user in camelCase
    return response.data;
  },

  async changePassword(
    oldPassword: string,
    newPassword: string,
    newPasswordConfirm: string,
  ): Promise<void> {
    await api.post("/auth/me/password/", {
      old_password: oldPassword,
      new_password: newPassword,
      new_password_confirm: newPasswordConfirm,
    });
  },
};
